export enum ServiceType {
  Residential = 1,
  Commercial = 2,
  Municipal = 3,
}
